export default __webpack_public_path__ + "img/dbCBwaXr.7a27bc64.svg";